// Local imports
import * as event from '../../datalayer/event.js';
import { push_data_object } from '../../datalayer/gtm/gtm_push.js';

// ===========================================================================
// Globals
// ===========================================================================

// Module name
export const MODULE_NAME = 'gcnav_datalayer';

export let global_vars = {};

// ===========================================================================
// gc-nav nav link datalayer
// ===========================================================================

// This assumes window.utag_data exists
function init_linkhandler(global) {
    let all_link = global.document.querySelectorAll('.iconNavBar-linkItem');
    for (let link of all_link) {
        link.addEventListener('click', event => {
            let utag_data = global.utag_data;
            onclick_link(global, utag_data, event.currentTarget);
        });
    }
}

function onclick_link(global, utag_data, link) {
    let link_data = link.dataset;

    utag_data['event_category'] = 'Ecommerce';
    utag_data['event_action'] = 'Promo Click';
    utag_data['event_label'] = 'OGC Navbar Promo Clicked';

    utag_data['promo_ids'] = link_data.productid;
    utag_data['promo_names'] = link_data.productname;
    utag_data['promo_creatives'] = link_data.productcreative;
    utag_data['promo_positions'] = link_data.position;

    let data_object = {
        event: 'select_promotion',
        ecommerce: {
            items: [],
        },
    };
    //== gtm-push: OGC Nav Bar Promo Clicks ==//
    data_object.ecommerce.items.push({
        promotion_id: link_data.productid,
        promotion_name: link_data.productname,
        creative_name: link_data.event_category,
        creative_slot: 'gc_nav',
    });
    push_data_object(data_object);

    event.dispatch(global, event.EventKind.PromoClick);
}

function store_navbar_promo_views(global) {
    //== gtm-push: OGC Nav Bar Promo Views ==//
    let all_link = global.document.querySelectorAll('.iconNavBar-linkItem');
    for (let link of all_link) {
        let dataset = link.dataset;
        global.promotions.push({
            id: dataset.productid,
            name: dataset.productname,
            creative: dataset.productcreative,
            position: dataset.position,
        });

        global.uaPromotions.push({
            id: dataset.productid,
            name: dataset.productname,
            creative: dataset.productcreative,
            position: dataset.position,
        });
    }
}

// Initialize module
export function initialize(global) {
    init_linkhandler(global);
    store_navbar_promo_views(global);
}
